import React from "react";
import { CheckCircleFilled, CloseCircleFilled, LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";

const LetterStatusIcon = ({ status, isLoading, size = 16 }) => {
  if (isLoading) {
    return <Spin indicator={<LoadingOutlined style={{ fontSize: size }} spin />} />;
  }
  if (status) {
    return <CheckCircleFilled style={{ color: "#52c41a", fontSize: size }} />;
  }
  return <CloseCircleFilled style={{ color: "#ff4d4f", fontSize: size }} />;
};

export default LetterStatusIcon;
